import { useEffect, useState } from "react";
import { TELEFON_ABFRAGE } from "../me/index.js";
/**
 * Ob das Fenster gerade ein TELEFON ist — dieselbe Medienabfrage wie in me-design
 * (`TELEFON_ABFRAGE`, max-width 743px; Story „Tabelle › Bearbeitungstabelle“). Folgt dem
 * Drehen und dem Ziehen des Fensters. Ohne `matchMedia` (alte WebViews) gilt: kein Telefon.
 *
 * Entscheid 42 (Dirk 17.10.2026): Bearbeitungstabellen bearbeiten ab Tablet direkt in der
 * Zeile; am Telefon stehen die Zeilen nur lesend, „Bearbeiten“ öffnet einen Dialog.
 */
export function useTelefon() {
    const abfrage = () => typeof window !== "undefined" && typeof window.matchMedia === "function"
        ? window.matchMedia(TELEFON_ABFRAGE) : null;
    const [telefon, setTelefon] = useState(() => abfrage()?.matches ?? false);
    useEffect(() => {
        const liste = abfrage();
        if (liste === null)
            return undefined;
        const beiWechsel = () => setTelefon(liste.matches);
        beiWechsel();
        liste.addEventListener("change", beiWechsel);
        return () => liste.removeEventListener("change", beiWechsel);
    }, []);
    return telefon;
}
//# sourceMappingURL=useTelefon.js.map